export const enum SharingLinkKind {
  uninitialized = 0,
  direct = 1,
  organizationView = 2,
  organizationEdit = 3,
  anonymousView = 4,
  anonymousEdit = 5,
  flexible = 6
}